<table class="ap-calendar-table" aria-describedby="">
    <caption class="ap-sr-only">
        Selecteer een jaar
    </caption>
    <thead class="ap-calendar-table-header">
        <tr>
            <th class="ap-calendar-table-header-divider" colspan="4"></th>
        </tr>
    </thead>
    <tbody
        ap-calendar-body
        aria-readonly="true"
        tabindex="0"
        [rows]="_years"
        [todayValue]="_todayYear"
        [selectedValue]="_selectedYear"
        [numCols]="4"
        [cellAspectRatio]="4 / 7"
        [activeCell]="_getActiveCell()"
        (selectedValueChange)="_yearSelected($event)"
        (keydown)="_handleCalendarBodyKeydown($event)"
    ></tbody>
</table>
